import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLocalStorage from 'vue-localstorage';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import VueRouterUserRoles from "vue-router-user-roles";
import VueInfiniteLoading from "vue-infinite-loading";
import IdleJs from 'idle-js'

import VueSweetalert2 from 'vue-sweetalert2';
import vueTippy from 'vue-tippy';
import vuetify from './plugins/vuetify'
import moment from "moment";
import VueMomentJS from "vue-momentjs";
import ExportarExcel from '@/components/ExportarExcel/ExportarExcel.vue';
import UploadExcelComponent from '@/components/UploadExcel/index.vue';
import VueHtml2Canvas from 'vue-html2canvas';
import VueIziToast from 'vue-izitoast';
import VueTheMask from 'vue-the-mask'
import VueCryptojs from 'vue-cryptojs'
import 'izitoast/dist/css/iziToast.css';
import 'regenerator-runtime/runtime'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-table'
import {
  funciones
} from './funciones.js'
import {
  funciones_s3
} from './funciones_s3.js'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';




Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.use(VueCryptojs);
//import "vuetify/dist/vuetify.min.css";
Vue.use(VueIziToast);
Vue.use(VueSweetalert2);
Vue.use(VueRouterUserRoles, {
  router
});
Vue.use(vueTippy);
Vue.use(VueInfiniteLoading);
Vue.use(BootstrapVue);
Vue.use(VueMomentJS, moment);
Vue.component('exportarExcel', ExportarExcel);
Vue.component('UploadExcelComponent', UploadExcelComponent);
Vue.use(VueTheMask);
Vue.use(VueLocalStorage, {
  name: 'local_storage',
  bind: true
});
Vue.use(VueHtml2Canvas);

Vue.prototype.$axios = axios;
Vue.prototype.$hostname = 'https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/';
Vue.config.productionTip = false

Vue.prototype.$funciones = funciones;
Vue.prototype.$funciones_s3 = funciones_s3;
Vue.prototype.$rules = {
  required: (v) => (v != undefined && v != null && v.toString().trim() != "") || "Este campo es requerido",
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || "Correo electrónico no valido";
  },
  entero: value => {
    const pattern = /^[\d]*$/;
    return pattern.test(value) || "Número entero no válido";
  },
  decimal: value => {
    const pattern = /^[\d]*(\.{0,1}[\d]*)$/;
    return pattern.test(value) || "Número decimal no válido";
  },
  password: value => {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&.])([A-Za-z\d$@$!%*?&.]|[^ ]){6,15}$/;
    return pattern.test(value) || "La contraseña debe tener al menos una letra mayuscula, una minuscula, un numero y un caracter, tamaño minimo 6";
  }
};

Vue.prototype.$catalogo_formas_pago = ["Efectivo", "Cheque nominativo", "Transferencia electrónica de fondos", "Tarjeta de crédito",
  "Monedero electrónico", "Dinero electrónico", "Vales de despensa", "Tarjeta de débito",
  "Tarjeta de servicio", "Otros"
];

Vue.prototype.$crypto = {
  encrypted: value => {
    if (value)
      return Vue.CryptoJS.AES.encrypt(value, "aAxtTljJVO%.cmt#.LMKs234.675q").toString();
    else
      return "";
  },
  decrypted: value => {
    if (value)
      return Vue.CryptoJS.AES.decrypt(value, "aAxtTljJVO%.cmt#.LMKs234.675q").toString(Vue.CryptoJS.enc.Utf8);
    else
      return "";
  },
  SHA256: value => {
    return Vue.CryptoJS.SHA256(value + "p0w3r", "aAxtTljJVO%.cmt#.LMKs234.675q").toString();;
  },
};


let getUser = Promise.resolve({
  role: 0
});


var idle = null;

if (Vue.prototype.$crypto.decrypted(Vue.prototype.$local_storage.get(Vue.prototype.$crypto.SHA256('uuid_usuario'))) != "") {

  getUser = Promise.resolve({
    role: 1,
  });
}
let aws = require('aws-sdk');

Vue.prototype.$uuid = require('uuid');

Vue.prototype.$tipo_usuarios = [{
  text: "Super Usuario",
  value: 1
}, {
  text: "Administrador",
  value: 2
}, {
  text: "Usuario",
  value: 3
}];


idle = new IdleJs({
  idle: 5 * 60000,
  onIdle() {
    idle.start();
    vm.verificaSesion('inactividad');
  },
});
idle.start();


axios.interceptors.request.use(async function(config) {
    if(config.url == "https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/carta_porte/general/login/" ||
        config.url == "https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/carta_porte/general/valida_token/" ||
        config.url == "https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/carta_porte/general/update_token/" ||
        config.url == "https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/carta_porte/administracion/update_usuario/")
    {
      return config;
    }
    await vm.verificaSesion(config.url);
    return config;
  },
  function(error) {
    return Promise.reject(error);
  });


var procesando = 0; //Para que no haga 2 llamadas a verificarSesion al mismo tiempo


const vm = new Vue({
  render: h => h(App),
  router,
  store,
  vuetify,
  data: () => ({
    urlLogout: Vue.prototype.$hostname + "carta_porte/general/logout/",
    urlVerificaSesion: Vue.prototype.$hostname + "carta_porte/general/verifica_sesion/",
  }),

  //vuetify,
  components: {
    App
  },
  template: "<App/>",
  methods: {
    verificaSesion: function(url) {
      var self = Vue.prototype.$local_storage;
      // if (url == 'inactividad')
      //   setTimeout(vm.reiniciaInactividad, 5 * 60000);
      if (Vue.prototype.$crypto.decrypted(self.get(Vue.prototype.$crypto.SHA256('uuid_usuario'))) != "" && (this.urlVerificaSesion != url && this.urlLogout != url) && (procesando == 0 || url == 'inactividad')) {
        var opcion = 1;
        if (url == 'inactividad')
          opcion = 0;
        else
          procesando = 1;

        //Verificar Sesión
        var datos = {
          usuario: Vue.prototype.$crypto.decrypted(self.get(Vue.prototype.$crypto.SHA256('uuid_usuario'))),
          opcion: opcion
        };
        axios.put(this.urlVerificaSesion, datos)
          .then((res) => {

            if (res.data == false) {
              var data = {
                uuid: Vue.prototype.$crypto.decrypted(self.get(Vue.prototype.$crypto.SHA256('uuid_usuario'))),
              };
              axios
                .post(this.urlLogout, data)
                .then(function(response) {})
                .catch(function(error) {})
                .then(function() {
                  window.localStorage.clear();
                  self.set(Vue.prototype.$crypto.SHA256("uuid_usuario"), Vue.prototype.$crypto.encrypted(""));
                  self.set(Vue.prototype.$crypto.SHA256("tipo_usuario"), 0);
                  Vue.prototype.$user.set({
                    role: 0
                  });
                  vm.cerrarSesion(1);
                });
            }

          })
          .catch((err) => {
            console.log(err);
          })
          .then(function() {
            if (url != 'inactividad')
              setTimeout(vm.reiniciaProcesando, 5 * 60000);
          });
      } else if (Vue.prototype.$crypto.decrypted(self.get(Vue.prototype.$crypto.SHA256('uuid_usuario'))) == Vue.prototype.$crypto.encrypted("") && vm.verificaUrlPermitida() == undefined) {
        vm.cerrarSesion(2);
      }
    },
    reiniciaInactividad: function() {
      vm.verificaSesion("inactividad");
      console.log("reiniciando");
    },
    reiniciaProcesando: function() {
      procesando = 0;
    },
    verificaUrlPermitida: function() {
      var x = window.location.pathname;
      //Son las url permitidas para acceso a usuarios invitados
      var permitidas = ["/", "/mobil"];
      var permitidasConParametros = [];
      var search = permitidas.find(element => element.toLowerCase() == x.toLowerCase());
      if (search == undefined) {
        search = permitidasConParametros.find(element => x.toLowerCase().indexOf(element.toLowerCase()) != -1);
      }

      return search;
    },
    cerrarSesion: function(opcion = 1) {
      var self = Vue.prototype.$local_storage;
      window.localStorage.clear();
      self.set(Vue.prototype.$crypto.SHA256("uuid_usuario"), Vue.prototype.$crypto.encrypted(""));
      self.set(Vue.prototype.$crypto.SHA256("tipo_usuario"), 0);
      Vue.prototype.$user.set({
        role: 0
      });
      procesando = 0;
      if (opcion == 1) {
        router.replace("/", () => {
          Vue.swal({
            type: 'warning',
            title: '¡Su sesión ha expirado!',
            text: 'Ingrese nuevamente al sistema.',
            footer: ''
          });
        });
      } else { //Solo enviamos a login
        router.replace("/");
      }
    },
  }
}).$mount("#app");

getUser.then(user => {
  Vue.prototype.$user.set(user);
  vm
});
